import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { messageEmailApi } from './messageEmail.api'
import messageEmailInitialState from './messageEmail.initialState'
import { MessageEmailErrorResponse, MessageEmailRequestPayload } from './messageEmail.types'

export const messageEmail = createAsyncThunk(
  urls.notifications.messageEmail,
  async (payload: MessageEmailRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await messageEmailApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const messageEmailSlice = createSlice({
  name: urls.notifications.messageEmail,
  initialState: messageEmailInitialState,
  reducers: {
    resetMessageEmail: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }

    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(messageEmail.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(messageEmail.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(messageEmail.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as MessageEmailErrorResponse
        state.success = null
      })
  }
})

export const { actions: messageEmailActions, reducer: messageEmailReducer } = messageEmailSlice
export const { resetMessageEmail } = messageEmailActions
export default messageEmailSlice.reducer
